import React, { useEffect, useState } from 'react'

interface SvgPreviewProps {
  url: string
}

const SvgPreview: React.FC<SvgPreviewProps> = ({ url }) => {
  const [svgContent, setSvgContent] = useState<string | null>(null)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch SVG')
        return res.text()
      })
      .then((text) => {
        setSvgContent(text)
        setError(false)
      })
      .catch(() => {
        setSvgContent(null)
        setError(true)
      })
  }, [url])

  if (error) {
    return <div className='text-red-500 text-sm'>⚠️ Failed to load SVG</div>
  }

  if (!svgContent) {
    return <div className='text-gray-400 text-sm'>Loading SVG...</div>
  }

  return (
    <div
      className='rounded-md w-full h-full'
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  )
}

export default SvgPreview
